export const BOX_SHADOW = '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)';
export const DROPDOWN_BOX_SHADOW = '0 6px 12px rgba(0, 0, 0, 0.175)';

export const FONT_FAMILY_SANS_SERIF = '"Open Sans", Helvetica, Arial, sans-serif';
export const HEADINGS_FONT_FAMILY = '"Montserrat", Helvetica, Arial, sans-serif';
